exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".spinner{display:flex;justify-content:center;align-items:center;height:20vh}@keyframes spin{to{transform:rotate(1turn)}}.icon{position:relative;display:inline-block;width:25px;height:25px;overflow:hidden}.icon__cnt{width:100%;height:100%;background:inherit;pointer-events:none;transform:translateX(0)}.dark .icon__cnt,.icon__cnt{fill:#0087f8}.icon--m{width:50px;height:50px}.icon__spinner{position:absolute;top:0;left:0;width:100%;height:100%}.icon--ei-spinner-2 .icon__spinner,.icon--ei-spinner .icon__spinner{animation:spin 1s steps(12) infinite}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-4bff05f0!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Spinner.vue
// module id = 938
// module chunks = 0